export enum ColorClass {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Danger = 'danger',
    Primary = 'primary',
    Secondary = 'secondary',
    Light = 'light',
    Dark = 'dark',
    White = 'white',
}
